/*!
 * @author electricessence / https://github.com/electricessence/
 * Licensing: MIT
 */
define(["require", "exports", "./EmptyEnumerator"], function (require, exports, EmptyEnumerator_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var EmptyEnumerable = /** @class */ (function () {
        function EmptyEnumerable() {
            this.isEndless = false;
        }
        EmptyEnumerable.prototype.getEnumerator = function () {
            return EmptyEnumerator_1.EmptyEnumerator;
        };
        return EmptyEnumerable;
    }());
    exports.EmptyEnumerable = EmptyEnumerable;
});
